export const highlightBugReportButton = () => {
    const bugReportButton = document.getElementById('bugReportButtonId');
    if (bugReportButton != null) {
        bugReportButton.style.background = '#dbdbdb';
        bugReportButton.style.boxShadow = '0 0 10px 5px white';
    }
    const mobileBugReportButton = document.getElementById('mobileBugReportButtonId');
    if (mobileBugReportButton) {
        mobileBugReportButton.style.setProperty('z-index', '5000', 'important');
    }
    const mobileBugReportButtonFaBug = document.getElementById('mobileBugReportButtonFaBugId');
    if (mobileBugReportButtonFaBug != null) {
        mobileBugReportButtonFaBug.style.background = '#dbdbdb';
        mobileBugReportButtonFaBug.style.boxShadow = '0 0 10px 5px white';
        mobileBugReportButtonFaBug.style.borderRadius = '100%';
        mobileBugReportButtonFaBug.style.overflow = 'visible';
    }
}

export const unhighlightBugReportButton = () => {
    const bugReportButton = document.getElementById('bugReportButtonId');
    if (bugReportButton != null) {
        bugReportButton.style.background = 'transparent';
        bugReportButton.style.boxShadow = 'none';
    }
    const mobileBugReportButton = document.getElementById('mobileBugReportButtonId');
    if (mobileBugReportButton) {
        mobileBugReportButton.style.removeProperty('z-index');
    }
    const mobileBugReportButtonFaBug = document.getElementById('mobileBugReportButtonFaBugId');
    if (mobileBugReportButtonFaBug != null) {
        mobileBugReportButtonFaBug.style.background = 'transparent';
        mobileBugReportButtonFaBug.style.boxShadow = 'none';
        mobileBugReportButtonFaBug.style.borderRadius = '0';
        mobileBugReportButtonFaBug.style.overflow = 'hidden';
    }
}
